import { NextPage } from "next";
import { IPaymentFormFields } from "types";
import { getContentfulEntries } from "utils/contentful-api";
import LongPaymentForm from "../../../components/Forms/LongPaymentFlow";

const Payment: NextPage<{
  paymentForm: IPaymentFormFields;
}> = ({ paymentForm }) => {
  return (
    <section className="bg-white h-screen-with-header flex flex-col justify-center px-4">
      <LongPaymentForm paymentForm={paymentForm} />
    </section>
  );
};

export default Payment;

export async function getServerSideProps() {
  const [paymentForm] = await getContentfulEntries<IPaymentFormFields>(
    "paymentForm"
  );

  return {
    props: {
      paymentForm,
    },
  };
}
